import { render } from "./addressErrList.vue?vue&type=template&id=068f4182&scoped=true"
import script from "./addressErrList.vue?vue&type=script&lang=js"
export * from "./addressErrList.vue?vue&type=script&lang=js"

import "./addressErrList.vue?vue&type=style&index=0&id=068f4182&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-068f4182"

export default script